import { EEntityType, entityTypeToLink } from '@sharedInterfaces/globalEnums';
import { generateFullName } from '@sharedInterfaces/globalHelper';
import getEmployee from '@src/APIs/graphQl/Employee/getEmployee';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import MvpEmployeePage from '../../_UnderConstruction/MvpEmployeePage/MvpEmployeePage';
import Overlay from '../Overlay/Overlay';

interface EmployeeOverlayProps {
    employeeId: number;
    children: React.ReactNode;
    disabled?: boolean;
    open?: boolean;
    onClose?: () => void;
}

/**
 * EmployeeOverlay function component.
 * @param {EmployeeOverlayProps} props - The props object for the EmployeeOverlay component.
 * @returns {JSX.Element} The rendered EmployeeOverlay component.
 */
function EmployeeOverlay(props: EmployeeOverlayProps) {
    const employee = useSelector((state: AppState) => state.employees.find((e) => e.id === props.employeeId));
    const [error, setError] = React.useState<Error | null>(null);
    const systemBarNavigateUrl = entityTypeToLink(props.employeeId, EEntityType.EMPLOYEE, 'dashboard');

    return (
        <Overlay
            loaded={employee !== undefined}
            disabled={props.disabled}
            triggerItem={props.children}
            error={error}
            systemBarNavigateUrl={systemBarNavigateUrl}
            open={props.open}
            onClose={props.onClose}
            onFirstOpen={() => {
                getEmployee(props.employeeId).catch(setError);
            }}
        >
            {employee && <MvpEmployeePage entity={employee} inDialog={true} />}
        </Overlay>
    );
}

export default EmployeeOverlay;
